import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositByIdController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositByIdController.php
* @route '/api/check-deposit/{check_deposit}'
*/
const GetCheckDepositByIdController = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckDepositByIdController.url(args, options),
    method: 'get',
})

GetCheckDepositByIdController.definition = {
    methods: ["get","head"],
    url: '/api/check-deposit/{check_deposit}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositByIdController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositByIdController.php
* @route '/api/check-deposit/{check_deposit}'
*/
GetCheckDepositByIdController.url = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { check_deposit: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { check_deposit: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            check_deposit: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        check_deposit: typeof args.check_deposit === 'object'
        ? args.check_deposit.id
        : args.check_deposit,
    }

    return GetCheckDepositByIdController.definition.url
            .replace('{check_deposit}', parsedArgs.check_deposit.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositByIdController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositByIdController.php
* @route '/api/check-deposit/{check_deposit}'
*/
GetCheckDepositByIdController.get = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckDepositByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckDepositByIdController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckDepositByIdController.php
* @route '/api/check-deposit/{check_deposit}'
*/
GetCheckDepositByIdController.head = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCheckDepositByIdController.url(args, options),
    method: 'head',
})

export default GetCheckDepositByIdController